import type { StorePageConfig } from '@/app/(football)/[team]/store/_context/types';

export const fcseoulConfig: StorePageConfig = {
  titleSection: {
    title: '스토어',
    highlight: 'FC서울 팬카드',
    description: '상품을 만나보세요',
  },
};
